import React from "react";
import styled from "styled-components";
import { IUser } from "../../interfaces";

interface IProps {
  user: IUser | null;
}

const UserNameAndStatus: React.FC<IProps> = ({ user }) => {
  return (
    <React.Fragment>
      {user && user.displayName}
      {user && user.correspondenceStatus === "unfinished" && (
        <CorrespondenceStatus>(未対応)</CorrespondenceStatus>
      )}
    </React.Fragment>
  );
};

const CorrespondenceStatus = styled.span`
  color: red;
`;

export default UserNameAndStatus;
